import ServicesConfig from '@/config/ServicesConfig';
import Axios from 'axios';
import querystring from "querystring"
import ComunServices from "@/services/ComunServices";
import  AppConfig   from "@/config/AppConfig";
const followRedirects = require('follow-redirects');
followRedirects.maxBodyLength = 100 * 1024 * 1024; // 100 MB
Axios.defaults.maxContentLength = Infinity

export default {
	createOrderEmision(data){
		return Axios.post('/orderEmission/createOrderEmision', data)
	},
	createVehicleNewRisk(data) {
		return Axios.post('/orderEmission/createVehicleNewRisk', data)
	},
	createVehicleRenovation(data) {
		return Axios.post('/orderEmission/createVehicleRenovation', data)
	},
	createGeneralNewRisk(data) {
		return Axios.post('/orderEmission/createGeneralNewRisk', data)
	},
	createGeneralRenovation(data) {
		return Axios.post('/orderEmission/createGeneralRenovation', data)
	},
	createOtherMovements(data) {
		return Axios.post('/orderEmission/createOtherMovements', data)
	},
	validateDateSince(type, date) {
		let url =
			'/orderEmission/validateDateSince' +
			'?type=' + type +
			'&date=' + date;
		/* 		+'&t1='+filters.t1
				+'&t2='+filters.t2
				+'&t3='+filters.t3
				+'&t4='+filters.t4
				+'&t5='+filters.t5
				+'&t6='+filters.t6; */

		return Axios.get(url)
	},
	queryOrders(page, limit, filters, scopes, profile, agencyId,business_name_executive) {
		filters.idAgencia = agencyId
				
		if(scopes.includes("aps_executive") || scopes.includes("aps_promotor")){
			//filters.broker = localStorage.getItem("business_name")
			filters.broker = business_name_executive
		}else{
			filters.broker = profile.business_name;
			filters.usuarioCreadorName = null;
			filters.usuarioCreadorId = null;
		}
		if(scopes.includes("aps_promotor")){
			filters.esPromotor = true;
		}
		
		filters.page = page;
		filters.limit = limit;

		let url = '/orderEmission/queryOrders';

		return Axios.get(url, {
			params: filters
		})
	},
	validateEmailIam(data){
		return Axios.post('/orderEmission/validateEmailIam', data)
	},
	// ,
	// validateEmailSiaerp(data){
	// 	return Axios.post('/orderEmission/validateEmailSiaerp', data)
	// }
	findEmiById(idOrden){
		let url =
			'/orderEmission/findEmiById' +
			'?idOrden=' + idOrden;
			return Axios.get(url); 
	},
	findEmiByPolicy(policy) {
		let url =
			'/orderEmission/findEmiByPolicy' +
			'?poliza=' + policy;
		return Axios.get(url)
	},
	getEjecutivoAgenteIdentificacion(id , identification)
	{
		let url = AppConfig.siaerpBaseUrl + 'Siaerp/GetEjecutivoAgentePorIdentificacion?contratoSuper='+ id+'&identificacion=' + identification + '';
		return Axios.get(url);
	},
	sendMailWarning(info){
		let params ={
			Identificacion: info.Identificacion,
			Nombre: info.Nombre,
			Ramo: info.Ramo,
			Poliza: info.Poliza,
			Emi: info.Emi
		};
		return Axios.post(AppConfig.siaerpBaseUrl + `Siaerp/notificaciones/avisoPoliza`,params)
	},
	searchBrokerByUserId(userId){

		return Axios.get(AppConfig.siaerpBaseUrl + `Siaerp/GetBrokerByUserId/${userId}`)
	}
	

}